import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import UserList from "./UserList";
import { LangContext } from "../LangContext.jsx";
import Swal from "sweetalert2";

class ProviderUpdate extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        const directUpdateEnabled = this.directUpdateEnabled();
        const { form } = this.state;
        const data = {
            rfc: form.rfc,
            fiscal_name: form.fiscal_name,
            person_type: form.person_type,
            zipcode: form.zipcode,
            address1: form.address1,
            people_id: this.state.person.id,
            municipality_id: form.municipality_id, // asegúrate de enviar municipality_id
        };
        this.setState({ success: null, submitError: null });
        axios
            .post(directUpdateEnabled ? "/api/update-person-direct" : "/api/update-person-request", data)
            .then((res) => {
                Swal.fire({
                    icon: "success",
                    title: directUpdateEnabled ? "¡Datos actualizados!" : "¡Solicitud enviada!",
                    text: directUpdateEnabled ? "Los datos se actualizaron correctamente." : "La autorización ya fue solicitada al invitado.",
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                        popup: 'my-swal-height'
                    }
                });
                setTimeout(() => {
                    window.location.href = "/providers";
                }, 3000);
                this.setState({ success: null, submitError: null });
            })
            .catch((err) => {
                let msg = "Error al enviar los datos";
                if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                ) {
                    msg = err.response.data.message;
                }
                this.setState({ submitError: msg, success: null });
            });
    };

    directUpdateEnabled = () => {
        return this.props.direct_update_enabled === true || this.props.direct_update_enabled === "1";
    };

    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            person: null,
            form: {},
            loading: false,
            error: null,
            states: [],
            municipalities: [],
        };
    }

    componentDidMount() {
        const id = this.props.id;
        this.setState({ loading: true });
        axios
            .get(`/api/providers/${id}`)
            .then((res) => {
                const provider = res.data.provider;
                this.setState({ country_id: provider.country_id }, function () {
                    axios
                        .get(`/api/states?country=${this.state.country_id}`)
                        .then((res) => {
                            const states = res.data;
                            console.log(
                                "[ProviderUpdate] Estados recibidos:",
                                states
                            );
                            this.setState({ states });
                        });
                });

                // Check if provider.municipio, provider.municipio.state, and provider.municipio.state.id exist
                if (provider.municipio && provider.municipio.state && provider.municipio.state.id) {
                    axios
                        .get(
                            `/api/municipalities?state=${provider.municipio.state.id}`
                        )
                        .then((muniRes) => {
                            // Normaliza person_type a 'Física' si es 'Fisica'
                            if (provider.person_type === "Fisica") {
                                provider.person_type = "Física";
                            }
                            this.setState({
                                municipalities: muniRes.data,
                                form: {
                                    ...provider,
                                    state_id: provider.municipio.state.id,
                                    person_type: provider.person_type,
                                },
                                person: provider,
                                loading: false,
                                error: null,
                            });
                        });
                } else {
                    // If no state ID is available, just update the state without municipalities
                    if (provider.person_type === "Fisica") {
                        provider.person_type = "Física";
                    }
                    this.setState({
                        municipalities: [],
                        form: {
                            ...provider,
                            state_id: provider.municipio?.state?.id || null,
                            person_type: provider.person_type,
                        },
                        person: provider,
                        loading: false,
                        error: null,
                    });
                }
            })
            .catch((err) => {
                console.error(
                    "[ProviderUpdate] Error en /api/providers/:id:",
                    err
                );
                this.setState({
                    person: null,
                    loading: false,
                    error: "Error al cargar los datos del invitado",
                });
            });
    }

    render() {
        const { lang } = this.context;
        const { person, form = {}, loading, error } = this.state;
        const directUpdateEnabled = this.directUpdateEnabled();
        if (loading) return <div> </div>;
        if (error) return <div className="alert alert-danger">{error}</div>;
        if (!person) return <div>No se encontró el invitado.</div>;
        return (
            <div>
                <div>
                    <div className="bg-white rounded p-5 w-100 pb-10"  style={{
                            maxWidth: "100%",
                            margin: "0 auto",
                            boxShadow: "none",
                            border: "none",
                        }}     >
                        {!directUpdateEnabled && <div  className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center mb-5"
                            role="alert"  >
                            <div>  <span className="flaticon2-warning mr-2 icon-3x"></span>
                            </div>
                            <div>     
                                Para modificar los datos de la empresa de tu
                                invitado, es necesario solicitar su
                                autorización. Recibirá un correo y, al ingresar
                                a su plataforma, verá un mensaje con la
                                solicitud para aceptar o rechazar los cambios.
                            </div>
                        </div>}
                        <form
                            onSubmit={this.handleSubmit}
                            className="w-100"
                            style={{ padding: "0 40px" }}
                        >
                            <div className="row mt-2">
                                <div className="col-md-9">

                                 
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="text-muted text-left font-weight-bold mb-2">
                                            Razón Social
                                        </p>
                                        <input
                                            type="text"
                                            className="form-control font-weight-bold"
                                            name="fiscal_name"
                                            value={form.fiscal_name || ""}
                                            onChange={(e) =>
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        fiscal_name:
                                                            e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <p className="text-muted text-left font-weight-bold">
                                            Tipo de persona
                                        </p>
                                        <select
                                            className="form-control font-weight-bold"
                                            name="person_type"
                                            value={form.person_type || ""}
                                            onChange={(e) =>
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        person_type:
                                                            e.target.value,
                                                    },
                                                })
                                            }
                                        >
                                            <option value="">
                                                Selecciona tipo
                                            </option>
                                            <option value="Física">
                                                Física
                                            </option>
                                            <option value="Moral">Moral</option>
                                        </select>
                                    </div>
                                   
                                </div>
                                <div className="row text-left">
                                    <div className="col-md-6">
                                        <p className="text-muted font-weight-bold mt-2">
                                            RFC
                                        </p>
                                        <input
                                            type="text"
                                            className="form-control font-weight-bold"
                                            name="rfc"
                                            value={form.rfc || ""}
                                            onChange={async (e) => {
                                                const rfc = e.target.value;
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        rfc,
                                                    },
                                                    rfcValidation: undefined,
                                                });
                                                if (
                                                    this.state.country_id === 1
                                                ) {
                                                    try {
                                                        const res =
                                                            await axios.post(
                                                                "/api/validate-rfc",
                                                                {
                                                                    rfc,
                                                                    isInvitation: false,
                                                                    allowMoralProviders: true,
                                                                    country: 1,
                                                                    personType:
                                                                        "Física",
                                                                }
                                                            );
                                                        this.setState({
                                                            rfcValidation:
                                                                res.data,
                                                        });
                                                    } catch (err) {
                                                        this.setState({
                                                            rfcValidation: {
                                                                isValid: false,
                                                                message:
                                                                    "Error validando RFC",
                                                            },
                                                        });
                                                    }
                                                }
                                            }}
                                        />
                                        {this.state.country_id === 1 &&
                                            this.state.rfcValidation &&
                                            !this.state.rfcValidation
                                                .isValid && (
                                                <div className="text-danger font-weight-bold mt-1">
                                                    {this.state.rfcValidation
                                                        .message ||
                                                        "RFC inválido"}
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6">
                                        <p className="text-muted font-weight-bold mt-2">
                                            Pais
                                        </p>
                                        {this.state.country_id == 1 && "México"}
                                        {this.state.country_id == 2 && "Brasil"}
                                        {this.state.country_id == 3 &&
                                            "Colombia"}
                                    </div>
                                </div>
                                <div className="row text-left">
                                    <div className="col-md-6">
                                        <p className="text-muted text-left font-weight-bold mt-2">
                                            Estado
                                        </p>
                                        <select
                                            className="form-control font-weight-bold"
                                            name="state_id"
                                            value={form.state_id || ""}
                                            onChange={(e) => {
                                                const state_id = e.target.value;
                                                // cargar municipios y seleccionar el primero automáticamente
                                                axios
                                                    .get(
                                                        `/api/municipalities?state=${state_id}`
                                                    )
                                                    .then((res) => {
                                                        const municipios =
                                                            res.data;
                                                        let firstMuniId = "";
                                                        if (
                                                            municipios &&
                                                            municipios.length >
                                                                0
                                                        ) {
                                                            firstMuniId =
                                                                municipios[0]
                                                                    .id;
                                                        }
                                                        this.setState({
                                                            municipalities:
                                                                municipios,
                                                            form: {
                                                                ...form,
                                                                state_id,
                                                                municipality_id:
                                                                    firstMuniId,
                                                            },
                                                        });
                                                    });
                                            }}
                                        >
                                            <option value="">
                                                Selecciona estado
                                            </option>
                                            {this.state.states.map((state) => (
                                                <option
                                                    key={state.id}
                                                    value={state.id}
                                                >
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="text-muted text-left font-weight-bold mt-2">
                                            Municipio
                                        </p>
                                        <select
                                            className="form-control font-weight-bold"
                                            name="municipality_id"
                                            value={form.municipality_id || ""}
                                            onChange={(e) =>
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        municipality_id:
                                                            e.target.value,
                                                    },
                                                })
                                            }
                                            disabled={!form.state_id}
                                        >
                                            <option value="">
                                                Selecciona municipio
                                            </option>
                                            {this.state.municipalities.map(
                                                (muni) => (
                                                    <option
                                                        key={muni.id}
                                                        value={muni.id}
                                                    >
                                                        {muni.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="row text-left">
                                    <div className="col-md-6">
                                        <p className="text-muted font-weight-bold mt-2">
                                            C.P.
                                        </p>
                                        <input
                                            type="text"
                                            className="form-control font-weight-bold"
                                            name="zipcode"
                                            value={form.zipcode || ""}
                                            onChange={(e) =>
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        zipcode: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <p className="text-muted text-left font-weight-bold">
                                            Dirección
                                        </p>
                                        <input
                                            type="text"
                                            className="form-control font-weight-bold"
                                            name="address1"
                                            value={form.address1 || ""}
                                            onChange={(e) =>
                                                this.setState({
                                                    form: {
                                                        ...form,
                                                        address1:
                                                            e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-3">
                                <div className="col-md-12 d-flex align-items-center justify-content-center mt-8">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100"
                                            disabled={
                                                (this.state.country_id === 1 &&
                                                this.state.rfcValidation &&
                                                !this.state.rfcValidation
                                                    .isValid) ||
                                                !this.state.form.state_id
                                            }
                                        >
                                            {directUpdateEnabled ? "Actualizar datos" : "Solicitar autorización al Invitado"}
                                        </button>
                                    </div>
                                </div>
                                {this.state.submitError && (
                                    <div className="alert alert-danger mt-3">
                                        {this.state.submitError}
                                    </div>
                                )}
                              
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProviderUpdate;

if (document.getElementById("ProviderUpdate")) {
    ReactDOM.render(
        <ProviderUpdate />,
        document.getElementById("ProviderUpdate")
    );
}
